/**
 * Generated bundle index. Do not edit.
 */

export {ORMSelector,selectData} from './index';
